import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { HttpService, UtilityService } from './index';
import { tap, map, switchMap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class UtilityFlightService {

  private countryCache$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  private isDataLoaded = false; 

  passangerDataActive: any[] = [];
  isPushed;
  AddOnsData: any[] = [];
  passangerRule: any[] = [];
  countryList: any[] = [];
  private carrierNamesSource = new BehaviorSubject<any>(null); // Initialize with null or an empty array
  carrierNames$ = this.carrierNamesSource.asObservable(); // Observable for components to subscribe to
  private promoCode = new BehaviorSubject<any>(null);
  PromoCode$ = this.promoCode.asObservable();
  constructor(private http: HttpService, private util: UtilityService) { }
  setCarrierNames(carrierNames: any) {
    this.carrierNamesSource.next(carrierNames);
  }
  setPromoCode(PromoCode: any) {
    this.promoCode.next(PromoCode)
  }
  viewMoreFare = [
    { name: 'Super Saver', total_amount: 3657, currency: 'INR', 
      infoList: [
        { name: 'Cabin baggage included' },
        { name: 'Check-in baggage included' },
        { name: 'Cancellation fees apply' },
        { name: 'Date change chargeable' }
      ]
    }, { name: 'Flexi plus', total_amount: 5558, currency: 'INR', 
      infoList: [
        { name: 'Cabin baggage included' },
        { name: 'Check-in baggage included' },
        { name: 'Lower Cancellation fees' },
        { name: 'Free data change allowed' },
        { name: 'Free seats available' }
      ]
    }, { name: 'Easy refund', total_amount: 8685, currency: 'INR', 
      infoList: [
        { name: 'Cabin baggage included' },
        { name: 'Check-in baggage included' },
        { name: 'Date change chargeable' },
        { name: 'Full refund of upto ₹ 5,655 (over and above airline refund) per person per route if you cancel' }
      ]
    }
  ]
  
  pushPassangerActive(data: any) {
    this.passangerDataActive = data;
    this.isPushed = this.passangerDataActive; // Set the flag to true when data is pushed    
  }
  
  getPassanger() {
    return this.passangerDataActive;
    // if (this.isPushed) {
    // } else {
    //   return true; // Returning null when not pushed
    // }
  }

  pushAddOnsActive(data: any) {
    // console.log(data);
    this.AddOnsData = data;
  }

  getAddOns() {
    if (this.isPushed) {
      return this.AddOnsData;
    } else {
      return true; // Returning null when not pushed
    }
  }

  convertTimeStringToMinutes(timeString: string): number {
    const [hours, minutes] = timeString.split(":").map(Number);
    return hours * 60 + minutes;
  }

  getPassangerRule() {
    return this.passangerRule;
  }

  pushPassangerRule(data: any) {
    this.passangerRule = data;
  }

  fetchCountryCodeList(): Observable<any[]> {
    if (this.isDataLoaded) {
      return this.countryCache$.asObservable();
    } else {
      return this.http.flightget('apiV2/country/index').pipe(
        tap((res: any) => {
          this.countryCache$.next(res.data); 
          this.isDataLoaded = true; 
        }),
        switchMap(() => this.countryCache$.asObservable()) 
      );
    }
  }

  private currentDateSource = new BehaviorSubject<string | null>(null); // Initialize with null or a default value
  currentDate$ = this.currentDateSource.asObservable();

  getCurrentDate(): string | null {
    return this.currentDateSource.value;
  }

  pushCurrentDate(data: string): void {
    this.currentDateSource.next(data);
  }

  getFlightsByType(): any {
    const flightData = JSON.parse(localStorage.getItem('flight_search') || '{}');
    if (flightData.trip) {
      const types = ['one_way', 'round_way'].map(t => 
        (flightData[t]?.search_request?.origin?.country_code === 'IN' && flightData[t]?.search_request?.destination?.country_code === 'IN') ? 'domestic' : 'international'
      );
      return { type: types.every(t => t === 'domestic') ? 'domestic' : 'international' };
    }
    return { type: (flightData?.search_request?.origin?.country_code === 'IN' && flightData?.search_request?.destination?.country_code === 'IN') ? 'domestic' : 'international' };
  }

  getGstInformation(bookingId: string, callback: (gstInfo: any) => void): void {
    this.http.flightsave(`pg/paymentApi/CheckGstInformation`, { booking_id: bookingId }).subscribe(res => {
      if (res.code === 2000) {
        const gstInfo = res.data;
        callback(gstInfo);
      } else {
        callback(null); // Call callback with null if there's an error
      }
    }, err => {this.util.errorMessage(err)});
  }

  getPreviousBooking(): Observable<any[]> {
    const CHECK_USER_DATA = JSON.parse(localStorage.getItem('Flightcheck-user') || '{}');
    const allBookings = JSON.parse(localStorage.getItem('privious_booking') || '[]');
    const filterBookings = (bookings: any[]) => {
      const currentTime = new Date().getTime();
      const oneHourAgo = currentTime - 3600000;
      const filteredBookings = bookings.filter((booking: any) => {
        const createdTime = new Date(booking.created.replace(' ', 'T')).getTime(); // Convert to ISO format for consistency
        return createdTime >= oneHourAgo;
      });
      const sortedBookings = filteredBookings.sort((a: any, b: any) => {
        return new Date(b.created.replace(' ', 'T')).getTime() - new Date(a.created.replace(' ', 'T')).getTime();
      });
      localStorage.setItem('privious_booking', JSON.stringify(sortedBookings));
      return sortedBookings.slice(0, 1);
    };
    if (localStorage.getItem('FlightLoginToken')?.trim() && CHECK_USER_DATA?.user_info_id) {
      return this.http.flightget(`apiV2/user/carts`, { userId: CHECK_USER_DATA.user_info_id }).pipe(
        map(res => res.statusCode === 200 ? filterBookings(res.data.filter((b: any) => b.booking_status === 'Booked' || b.booking_status === 'In Process')) : [])
      );
    }
  
    return of(filterBookings(allBookings));
  }
}
